import { HEALTH_CHECK_FIELD } from './fieldKeys';
import type { HealthCheckBlockOptions } from './types';

export function resolveHealthCheckPaths(_prefix?: string, _options?: HealthCheckBlockOptions) {
  return { config: HEALTH_CHECK_FIELD };
}
